import React, { Component, Fragment } from "react";

import { inject, observer } from "mobx-react";
import { Link, withRouter } from "react-router-dom";
// import NumberFormat from "react-number-format";
// import moment from "moment";
import { ProfileType, BookingType, BookingStatusType, LineupStatusType, RosterDividendType } from "../../types/enum";
import "./BookingDetails.css";
import { Grid, Typography, Button, Checkbox,Menu, Snackbar, IconButton, Tooltip,MenuItem, CircularProgress } from "@material-ui/core";
import ResponsiveTable from "../table/ResponsiveTable";
import BookingStatusBadge from "./BookingStatusBadge";
import FacebookPostDialog from "../facebookPostDialog/FacebookPostDialog";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import ClearIcon from "@material-ui/icons/Clear";
import PrintModal from "./PrintModal.js/PrintModal";
import PrintIcon from "@material-ui/icons/Print";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import facebook from "../../img/facebook-box.svg";
import ConfirmationModal from "../modal/ConfirmationModal";
import currencyHelper from '../../helper/currency';
import FacebookSharePostDialog from "../facebookSharePostDialog/FacebookSharePostDialog";
import CheckCircle from "@material-ui/icons/CheckCircle";
import DirectionsIcon from "@material-ui/icons/Directions";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import GetAppIcon from "@material-ui/icons/GetApp";
import superCalculationHelper from "../../helper/superCalculationHelper"
import bookingCalculationHelper from "../../helper/bookingCalculationHelper"
import HelpOutlineIcon from "@material-ui/icons/HelpOutline"
import BulkEditModal from "./BulkEditModal"
import BulkCancelModal from "./BulkCancelModal"
import agent from "../../agent"

const CANCELLABLE_STATUSES = [
    BookingStatusType.New.ordinal,
    BookingStatusType.Hold.ordinal,
    BookingStatusType.Accepted.ordinal,
    BookingStatusType.LineupSet.ordinal,
    BookingStatusType.SetlistSet.ordinal,
    BookingStatusType.Ready.ordinal,
    BookingStatusType.Resent.ordinal,
    BookingStatusType.SentToAct.ordinal,
    BookingStatusType.PlayerNotified.ordinal,
    BookingStatusType.AllPlayerConfirmed.ordinal,
    BookingStatusType.ClientNotified.ordinal,
    BookingStatusType.PlayerInvitedAndClientNotified.ordinal,
    BookingStatusType.PlayerConfirmedAndClientNotified.ordinal
];

const FACEBOOK_ENABLED = process.env.REACT_APP_FACEBOOK_ENABLED === "true";

const BOOKING_STATUS = [
    "New",
    "Declined",
    "Negotiate",
    "Accepted",
    "LineupSet",
    "SetlistSet",
    "Ready",
    "Completed",
    "Paid",
    "Cancelled",
    "Resent",
    "Draft",
    "Incomplete",
    "Cancelled By Act",
    "Cancelled By Act",
    "SentToAct",
    "PlayerNotified",
    "PlayerDeclined",
    "AllPlayerConfirmed",
    "ClientNotified",
    "PlayerInvitedAndClientNotified",
    "PlayerConfirmedAndClientNotified"
];

@inject("profileStore", "bookingRequestStore", "templateStore", "facebookStore", "reportStore")
@withRouter
@observer
class BookingAccepted extends Component {
    state = {
        columns: [],
        acknowledgeSnackbarState: false,
        booking: undefined,
        selectedBookings: [],
        showPrintOption: false,
        sharedBookings: [],
        actionAnchor: [],
        duplicateModalState: true,
        duplicateModalState: null,
        openDuplicateSnackbar: false,
        duplicateBooking: undefined,
        page: 1,
        isExporting: false,
        bulkEditModalOpen: false,
        bulkCancelModalOpen: false
    };

    rows = [];

    setActionAnchor = (element, bookingId) => {
        var tempAnchor = [];
        tempAnchor[bookingId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    unsetActionAchnor = bookingId => {
        this.setState({ ...this.state, actionAnchor: [] });
    };
    
    componentDidMount() {
        const { match } = this.props;
        const {
            currentProfile
        } = this.props.profileStore;

        const { upcomings } = this.props.bookingRequestStore;
        const { social } = this.props;
        
        if (this.props.profileType === "agent") {
            if(social){
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date/Time", width: "10%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "venue", label: "Venue", width: "12%" },
                        { key: "actName", label: "Act Name", width: "12%" },
                        { key: "status", label: "Status", width: "8%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                        { key: "socialPosts", label: "Social Posts",  width: "15%", align: 'center', style: {whiteSpace: 'nowrap'}},
                        { key: "action", label: "Actions", width: "8%" }
                    ]
                });
            }else{
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date/Time", width: "12%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "venue", label: "Venue", width: "14%" },
                        { key: "actName", label: "Act Name", width: "14%" },
                        { key: "status", label: "Status", width: "10%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                        { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "agentFee", label: <Tooltip title="Agent Fee"><span>Agent Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "actFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, sortable: true, width: "9%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "superFee", label: <Tooltip title="Superannuation Fee"><span>Super Fee</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "8%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "action", label: "Actions", width: "7%" }
                    ]
                });
            }
           
        } else if (this.props.profileType === "musician") {
            if(social){
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date/Time", width: "10%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "venue", label: "Venue", width: "12%" },
                        { key: "actName", label: "Act Name", width: "12%" },
                        { key: "status", label: "Status", width: "8%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                        !social && { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "7%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "7%", align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "myFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, width: "7%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "superFee", label: "Super Fee", sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "socialPosts", label: "Social Posts",  width: "10%", align: 'center', style: {whiteSpace: 'nowrap'}},
                        { key: "action", label: "Actions", width: "8%" }
                    ]
                });
            }else{
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date/Time", width: "10%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "venue", label: "Venue", width: "12%" },
                        { key: "actName", label: "Act Name", width: "12%" },
                        { key: "status", label: "Status", width: "8%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                        { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "7%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "7%", align: 'left', style: { flexDirection: 'row' } },
                        { key: "myFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, width: "7%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "superFee", label: "Super Fee", sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                        { key: "action", label: "Actions", width: "8%" }
                    ]
                });
            }
            
        } else if (this.props.profileType === "staff") {
            if(social){
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "status", label: "Status", width: "15%" },
                        { key: "actName", label: "Act Name", width: "15%" },
                        { key: "venue", label: "Venue", width: "15%" },
                        !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "10%", isNumber:true, align: 'left', style: { flexDirection: 'row' } }, 
                        !social && { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "actFee", label: "Performance Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                        // { key: "interested", label: "Interested", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "going", label: "Going", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } },
                        // { key: "socialPosts", label: "Social Posts",  width: "15%", align: 'center', style: {whiteSpace: 'nowrap'}},
                        { key: "socialPosts", label: "Social Posts",  width: "15%", align: 'center', style: {whiteSpace: 'nowrap'}},
                        { key: "action", label: "", width: "5%" }
                    ]
                });
            }else{
                this.setState({
                    ...this.state,
                    columns: [
                        { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                        { key: "status", label: "Status", width: "15%" },
                        { key: "actName", label: "Act Name", width: "15%" },
                        { key: "venue", label: "Venue", width: "15%" },
                        !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "10%", isNumber:true, align: 'left', style: { flexDirection: 'row' } }, 
                        !social && { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        !social && { key: "actFee", label: "Performance Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                        // { key: "interested", label: "Interested", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "going", label: "Going", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                        // { key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } },
                        // { key: "socialPosts", label: "Social Posts",  width: "15%", align: 'center', style: {whiteSpace: 'nowrap'}},
                        { key: "action", label: "", width: "5%" }
                    ]
                });
            }
           
            
        }else if (this.props.profileType === "PrivateHire") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "20%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "20%" },
                    { key: "actName", label: "Act Name", width: "20%" },
                    { key: "venue", label: "Venue", width: "25%" },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "15%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                    // { key: "interested", label: "Interested", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    // { key: "going", label: "Going", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    // { key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } },
                    // { key: "socialPosts", label: "Social Posts",  width: "15%", align: 'center', style: {whiteSpace: 'nowrap'}},
                    
                    { key: "action", label: "", width: "5%" }
                ]
            });
        }

        if(match.params.tab === "upcomingSuper" && match.params.id){
            this.props.reportStore.setActAdminId(match.params.id)
        }else{
            this.props.reportStore.setActAdminId(undefined)
        }
    }

    loadGigs(page){
        const {
            currentProfile
        } = this.props.profileStore;
        this.props.bookingRequestStore.showLoadingState()
        this.props.bookingRequestStore.loadUpcomingGigs(currentProfile?.id,page).then(() => {
            this.props.bookingRequestStore.hideLoadingState();
        })
    }

    handleShowMore = e => {
        const {
            upcomingPage
        } = this.props.bookingRequestStore;
        var page = parseInt(upcomingPage) + 1;
        this.loadGigs(page)
    };

    updatedSharedBookingState = () => {
        const { booking } = this.props.facebookStore;
        const { sharedBookings } = this.state;
        let postedIds = sharedBookings;
        if (booking) {
            postedIds.push(booking.id);
        }
        this.setState({
            ...this.state,
            sharedBookings: postedIds,
        })
    }

    openAcknowledgeSnackbar = booking => {
        this.setState({
            ...this.state,
            acknowledgeSnackbarState: true,
            booking: booking
        });
    };

    closeAcknowledgeSnackbar = () => {
        this.setState({
            ...this.state,
            acknowledgeSnackbarState: false,
            booking: undefined
        });
    };

    handleAcknowledgeBooking = booking => {
        let message = `Catch ${booking.actName} playing here on ${moment(new Date(booking.dateStart)).format("DD-MM-YYYY")} from ${moment(
            booking.timeStart,
            "HH:mm:ss"
        ).format("hh:mm A")} to ${moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A")}. `;
        if (booking.ticketUrl !== "") {
            message = message + `Tickets on sale ${booking.ticketUrl}.`;
        }
        this.props.facebookStore.setPostMessage(message);
        this.props.facebookStore.setBooking(booking);
        if (booking.venue?.facebookPageId) {
            this.props.facebookStore.openFacebookPostDialog(booking.venue);
        } else {
            this.props.bookingRequestStore.venueStaffAcknowledgeGigs(booking.id).then(response => {
                this.openAcknowledgeSnackbar(response);
            });
        }
    };

    handleSharePost = async (booking, profile) => {
        const { currentProfile } = this.props.profileStore;
        let formattedVenueName = booking.venueName ? "#" + booking.venueName?.replace(/ /g, "") : booking.venue ? "#" + booking.venue?.profileName?.replace(/ /g, "") : "";
        let formattedActName = booking.actName ? "#" + booking.actName.replace(/ /g, "") : "";
        let formattedActName2 = booking.actName ? booking.actName : booking.act ? booking.act?.actName : ""
        let bookTableUrl = booking.venue && booking.venue.bookTableUrl ? booking.venue.bookTableUrl  : ""
        

        let message = `Hi Folks, Catch ${formattedActName2} playing here on ${moment(new Date(booking.dateStart)).format("DD-MM-YYYY")}  from ${moment(
            booking.timeStart,
            "HH:mm:ss" 
        ).format("hh:mm A")} to  ${moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A")}.  Come and enjoy some great live entertainment - get in early and book a table! \n \n ${bookTableUrl} \n \n ${formattedActName} ${formattedVenueName} #livegigs #livegigs #livemusic #liveentertainment #hotgiggity`
        if(currentProfile?.type === ProfileType.Musician.ordinal){
            message = `Hi Folks!  I am playing a gig at ${formattedVenueName} on the ${moment(new Date(booking.dateStart)).format("DD-MM-YYYY")}  from ${moment(
                booking.timeStart,
                "HH:mm:ss" 
            ).format("hh:mm A")} to  ${moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A")}.  See you there!! \n \n #livegigs #livemusic #liveentertainment #hotgiggity `
        }
      
        if (booking.ticketUrl && booking.ticketUrl !== "") {
            message = message + `Tickets on sale ${booking.ticketUrl}.`;
        }
        if(booking.venue){
            booking.venue.backgroundImages = await this.props.profileStore.getBackgroundImage(booking.venue.id);
        }
        if(booking.act){
            booking.act.backgroundImages = await this.props.profileStore.getBackgroundImage(booking.act.id);
        }
        this.props.facebookStore.setPostMessage(message);
        this.props.facebookStore.setBooking(booking);
        if (profile.type === ProfileType.Musician.ordinal) {
            if (booking.act?.facebookPageId && booking.act?.actAdminId === currentProfile?.id) {
                this.props.facebookStore.openFacebookSharePostDialog(booking.act);
            } else {
                this.props.facebookStore.openFacebookSharePostDialog(currentProfile);
            }
        } else if (profile.type === ProfileType.Staff.ordinal) {
            this.props.facebookStore.openFacebookSharePostDialog(booking.venue);
              // this.props.bookingRequestStore.venueStaffAcknowledgeGigs(booking.id).then(response => {
            //     this.openAcknowledgeSnackbar(response);
        } else if (profile.type === ProfileType.Agent.ordinal) {
            this.props.facebookStore.openFacebookSharePostDialog(booking.agent);
        }
    };

    handleUndoAcknowledge = () => {
        if (this.state.booking) {
            this.props.bookingRequestStore.venueStaffUnacknowledgeGigs(this.state.booking.id).then(response => {
                this.closeAcknowledgeSnackbar();
                this.props.templateStore.openSnackbar(`Changes to ${response.title} has been reverted.`);
            });
        }
    };

    getBookingStatus = booking => {
        const { currentProfile } = this.props.profileStore
        if (booking.type === BookingType.Adhoc.ordinal) {
            // if (booking.status === BookingStatusType.Accepted.ordinal && !booking.notifyClient) {
            //     return "Incomplete";
            // }
            return BOOKING_STATUS[booking.status];
        } else {
            if (booking.createdById !== currentProfile?.id && (booking.status === BookingStatusType.AllPlayerConfirmed.ordinal || booking.status === BookingStatusType.PlayerConfirmedAndClientNotified.ordinal)) {
                return "Accepted"
            }
            return BOOKING_STATUS[booking.status];
        }
    };

    exportToCSV = () => {
        const { selectedBookings } = this.state;
        const { upcomings } = this.props.bookingRequestStore;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        this.setState({ isExporting: true });
        
        try {
            const selectedIds = selectedBookings.map(row => row.id);
            const originalBookings = upcomings.filter(booking => selectedIds.includes(booking.id));
            
            const data = originalBookings.map(booking => {
                const collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile);
                const venueName = booking.venueName || booking.venue?.profileName || "";
                const venueAddress = booking.venue?.street1 
                    ? `${booking.venue.street1}${booking.venue.city ? ', ' + booking.venue.city : ''}${booking.venue.state ? ', ' + booking.venue.state : ''}`
                    : "";
                
                return {
                    date: moment(booking.dateStart).format("DD/MM/YYYY"),
                    timeStart: moment(booking.timeStart, "HH:mm:ss").format("hh:mm A"),
                    timeEnd: moment(booking.timeEnd, "HH:mm:ss").format("hh:mm A"),
                    venueName: venueName,
                    venueAddress: venueAddress,
                    actName: booking.actName || booking.act?.actName || "",
                    status: this.getBookingStatus(booking),
                    venueClientFee: parseFloat(collectedFee.gigFee || 0).toFixed(2),
                    agentFee: parseFloat(collectedFee.agentFeeNumber || 0).toFixed(2),
                    performanceFee: parseFloat(collectedFee.performanceFee || booking.actFee || 0).toFixed(2),
                    invoiceAmount: parseFloat(collectedFee.feePaidToActNumber || 0).toFixed(2)
                };
            });

            const headers = ["Date", "Time Start", "Time End", "Venue Name", "Venue Address", "Act Name", "Status", "Venue/Client Fee", "Agent Fee", "Performance Fee", "Invoice Amount"];
            
            const csvContent = [
                headers.join(","),
                ...data.map(row => [
                    `"${row.date}"`,
                    `"${row.timeStart}"`,
                    `"${row.timeEnd}"`,
                    `"${row.venueName.replace(/"/g, '""')}"`,
                    `"${row.venueAddress.replace(/"/g, '""')}"`,
                    `"${row.actName.replace(/"/g, '""')}"`,
                    `"${row.status}"`,
                    row.venueClientFee,
                    row.agentFee,
                    row.performanceFee,
                    row.invoiceAmount
                ].join(","))
            ].join("\n");

            const agencyName = currentProfile?.profileName || "Agency";
            
            let venueLabel = "All Venues";
            if (venueId && originalBookings.length > 0) {
                const firstBooking = originalBookings[0];
                venueLabel = firstBooking.venueName || firstBooking.venue?.profileName || "All Venues";
            }
            
            const dates = originalBookings.map(b => moment(b.dateStart));
            let dateRange = moment().format("YYYY-MM-DD");
            if (dates.length > 0) {
                const minDate = moment.min(dates).format("DD-MM-YYYY");
                const maxDate = moment.max(dates).format("DD-MM-YYYY");
                dateRange = minDate === maxDate ? minDate : `${minDate} to ${maxDate}`;
            }
            
            const safeAgencyName = agencyName.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            const safeVenueLabel = venueLabel.replace(/[^a-zA-Z0-9 ]/g, "").trim();
            const filename = `${safeAgencyName} - ${safeVenueLabel} - Upcoming Gigs - ${dateRange}.csv`;

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting CSV:", error);
            this.props.templateStore.openSnackbar("Error exporting CSV. Please try again.");
        } finally {
            this.setState({ isExporting: false });
        }
    };

    openBulkEditModal = () => {
        this.setState({ bulkEditModalOpen: true });
    };

    closeBulkEditModal = () => {
        this.setState({ bulkEditModalOpen: false });
    };

    openBulkCancelModal = () => {
        this.setState({ bulkCancelModalOpen: true });
    };

    closeBulkCancelModal = () => {
        this.setState({ bulkCancelModalOpen: false });
    };

    handleBulkCancelComplete = () => {
        this.setState({ selectedBookings: [] });
    };

    handleBulkEditSubmit = async (selectedRows, updates) => {
        const { currentProfile } = this.props.profileStore;
        
        try {
            const result = await this.props.bookingRequestStore.bulkUpdateBookings(selectedRows, updates, true, currentProfile?.id);

            this.setState({ selectedBookings: [] });
            
            return result;
        } catch (error) {
            console.error("Bulk edit error:", error);
            throw error;
        }
    };

    isRelatedCreator = (booking) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if (!currentProfile) return false;
        return currentProfile.id === booking.createdById || (booking.relatedCreatorId && booking.relatedCreatorId.includes(String(currentProfile.id)));
    };

    renderTableCustomActions = () => {
        const { selectedBookings, isExporting } = this.state;
        const isDisabled = !selectedBookings || selectedBookings.length === 0;
        const hasNonCreator = !isDisabled && selectedBookings.some(row => {
            const booking = this.props.bookingRequestStore.upcomings.find(b => b.id === row.id);
            return !booking || !this.isRelatedCreator(booking);
        });
        const isBulkDisabled = isDisabled || hasNonCreator;
        const isBulkEditDisabled = isBulkDisabled || selectedBookings.length > 40;
        const isBulkCancelDisabled = isBulkDisabled || selectedBookings.length > 40;
        return (
            <Fragment>
                <Button 
                    onClick={this.openBulkEditModal} 
                    disabled={isBulkEditDisabled} 
                    style={{ color: !isBulkEditDisabled ? "#fff" : undefined }}
                >
                    <EditIcon style={{ color: !isBulkEditDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    Bulk Edit
                </Button>
                <Button 
                    onClick={this.openBulkCancelModal} 
                    disabled={isBulkCancelDisabled} 
                    style={{ color: !isBulkCancelDisabled ? "#fff" : undefined }}
                >
                    <CancelIcon style={{ color: !isBulkCancelDisabled ? "#fff" : undefined, marginRight: 4 }} />
                    Bulk Cancel
                </Button>
                {selectedBookings.length > 40 && (
                    <span style={{ color: "#e65100", fontSize: 13, fontWeight: 500, marginLeft: 8, alignSelf: "center" }}>
                        &#9888; Bulk actions are limited to 40 bookings. Please deselect some.
                    </span>
                )}
                <Button onClick = { this.openPrintOptionModal } disabled = { isDisabled } style={{ color: !isDisabled ? "#fff" : undefined }}>
                    <PrintIcon style={{ color: !isDisabled ? "#fff" : undefined }} />
                    Print
                </Button>
                <Button 
                    onClick={this.exportToCSV} 
                    disabled={isDisabled || isExporting} 
                    style={{ color: !isDisabled && !isExporting ? "#fff" : undefined, marginLeft: 8 }}
                >
                    {isExporting ? (
                        <CircularProgress size={20} style={{ color: "#fff", marginRight: 4 }} />
                    ) : (
                        <GetAppIcon style={{ color: !isDisabled ? "#fff" : undefined }} />
                    )}
                    {isExporting ? "Exporting..." : "Download CSV"}
                </Button>
            </Fragment>
        )
    };

    renderFooterRow = () => {
        let { upcomings } = this.props.bookingRequestStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        if (venueId) {
            upcomings = upcomings.filter(x => x.venueId === venueId);            
        }
        
        var totalFee = 0;
        var totalActFee = 0;
        var totalAgentFee = 0;
        var totalMyFee = 0
        var totalSuperFee = 0;
        var totalFeedPaidtoAct = 0
        
       
        
        upcomings.map(booking => {
                                var row = {};
                               
                                let agentActOwner = currentProfile?.type === ProfileType.Agent.ordinal && booking.createdById !== currentProfile?.id && booking.act.actAdminId === currentProfile?.id;

                                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                                let actOwner = booking.act?.userId === currentProfile?.userId;

                                let displayFeeAmount;

                                const isAgentOrStaff = (profileType === "agent" || profileType === "staff");

                                const shouldShowExpandedFee = isAgentOrStaff && booking.isApproved;

                                if (shouldShowExpandedFee) {
                                    displayFeeAmount = collectedFee.gigFee + booking.extraGigFee;
                                } else if (agentActOwner) {
                                    displayFeeAmount = collectedFee.performanceFee;
                                } else {
                                    displayFeeAmount = collectedFee.gigFee;
                                }

                                let displayActFeeAmount;
                                if (agentActOwner) {
                                    displayActFeeAmount = booking.actFee;
                                } else if (this.props.profileType === "musician" && !actOwner) {
                                    displayActFeeAmount = 0;
                                } else {
                                    displayActFeeAmount = booking.actFee;
                                }

                                totalFee = totalFee + parseFloat(displayFeeAmount);
                                totalActFee = totalActFee + parseFloat(displayActFeeAmount)
                                totalAgentFee = totalAgentFee + parseFloat(collectedFee.agentFeeNumber);
                                totalMyFee = totalMyFee + this.props.profileType === 'musician' ? parseFloat(collectedFee.myFee) : 0;
                              
                                totalSuperFee = totalSuperFee + parseFloat(collectedFee.superFeeNumber)
                                totalFeedPaidtoAct = totalFeedPaidtoAct + parseFloat(collectedFee.feePaidToActNumber)
                                
                            })
        return {
            gigFee: ( (currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalFee, 2)}`,
            actFee: ( (currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalActFee, 2)}`,
            agentCommissionAmount: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            agentFee: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalAgentFee, 2)}`, 
            myFee: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalMyFee, 2)}`,
            superFee: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalSuperFee, 2)}`,
            feePaidToAct: ((currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
            ? <i class="far fa-eye-slash"></i>  
            : `${currentProfile?.currencySymbol + currencyHelper.formatMoney(totalFeedPaidtoAct, 2)}`,
            style: {
                textAlign: 'left'
            }
        }
    }

    getCheckedRows = rows => {
        this.setState({
            ...this.state,
            selectedBookings: rows
        })
    };

    openPrintOptionModal = () => {
        this.setState({
            ...this.state,
            showPrintOption: true
        })
    }

    closePrintOptionModal = () => {
        this.setState({
            ...this.state,
            showPrintOption: false
        })
    }

    isConnectedToFb = (booking) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        let status;

        if (this.props.profileType === 'musician') {
            status = currentProfile && currentProfile?.facebookPageId || booking.act?.facebookPageId ? true : false;
        } else if (this.props.profileType === 'staff') {
            status = booking.venue?.facebookPageId ? true : false;
        } else if (this.props.profileType === 'agent') {
            status = currentProfile && currentProfile?.facebookPageId ? true : false
        }

        return status
    };

    handleOpenDuplicateBookingModal = booking => this.setState({ duplicateModalState: true, duplicateBooking: booking, actionAnchor: [] });
    handleCloseDuplicateBookingModal = () => {
        this.setState({
            ...this.state,
            duplicateModalState: false,
            duplicateBooking: null
        });
    };
    handleDupicateRequest = () => {
        const { duplicateBooking } = this.state;
        const bookingRequestId = duplicateBooking?.bookingRequests?.filter(x => !x.deleted)[0]?.id || 0;

        this.props.bookingRequestStore.getDetailBookingCalendar(duplicateBooking.id, bookingRequestId)
            .then(() => {
                const freshBooking = this.props.bookingRequestStore.bookingDetail;
                this.props.bookingRequestStore.setDuplicateBooking(freshBooking);

                this.props.history.push(
                    `/booking/new?actId=${freshBooking?.actId ? freshBooking?.actId : "undefined"}&duplicateBooking=${true}&venueId=${freshBooking?.venueId ? freshBooking?.venueId : "undefined"}&dateStart=${freshBooking?.dateStart ? moment(freshBooking?.dateStart, "DD-MM-YYYY").add(1, "days").format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY")}`,
                    { from: 'fromBookingStation' }
                );
                this.handleCloseDuplicateBookingModal();
                this.setState({ openDuplicateSnackbar: true });
            });
    };

    handleSnackbarEditClose = (event, reason) => {
        this.setState({ openDuplicateSnackbar: false });
    };
    
    renderSocialTip = () => {
        const { profileType } = this.props;
        let tip = "";
        switch (profileType) {
            case "musician":
                tip = "These are your upcoming gigs. Connect your act profile to your facebook page to push your gigs to Facebook"
                break;
            case "agent":
                tip = "These are your upcoming gigs. Connect your agency profile to your facebook page to push your gigs to Facebook."
                break;
            case "staff":
                tip = "These are your upcoming gigs. Connect each of your venue profiles to your Facebook page to publish your gigs to Facebook"
                break;
        
            default:
                break;
        }

        return tip
    }

    renderMobileGigCard = (row, index, onCheckboxChange) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-select">
                    <Checkbox
                        checked={!!row.checked}
                        onChange={onCheckboxChange}
                        disabled={row.disableCheckbox}
                        color="primary"
                        style={{ padding: '4px' }}
                    />
                    <span className="mobile-gig-card-select-label">Select</span>
                </div>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentCommissionAmount}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.myFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-act">
                        <div className="mobile-gig-card-status">{row.status}</div>
                        {row.actName}
                    </div>
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    renderAgentMobileGigCard = (row, index, onCheckboxChange) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-select">
                    <Checkbox
                        checked={!!row.checked}
                        onChange={onCheckboxChange}
                        disabled={row.disableCheckbox}
                        color="primary"
                        style={{ padding: '4px' }}
                    />
                    <span className="mobile-gig-card-select-label">Select</span>
                </div>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-act" style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
                    <div className="mobile-gig-card-status">{row.status}</div>
                    {row.actName}
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.actFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { upcomings } = this.props.bookingRequestStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { profileType, social } = this.props;
        const { venueId } = this.props.reportStore;
        const { showPrintOption, selectedBookings } = this.state;
        const { match } = this.props;

        if (venueId) {
            upcomings = upcomings.filter(x => x.venueId === venueId);
        }
        
        this.props.bookingRequestStore.setBookingsCount("upcomings", upcomings);
        
        const bookingHighlight = match.params.tab === "upcoming" && match.params.id ? match.params.id : null
        var newColumns = []
        if(currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && currentProfile?.viewOnly){
            newColumns= [
                    { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "15%" },
                    { key: "actName", label: "Act Name", width: "15%" },
                    { key: "venue", label: "Venue", width: "15%" },
                    !social && { key: "gigFee", label: "Gig Fee", sortable: true, width: "10%", isNumber:true, align: 'left', style: { flexDirection: 'row' } }, 
                    // { key: "interested", label: "Interested", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    // { key: "going", label: "Going", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    // { key: "acknowledge", label: "Acknowledged", width: "10%", style: { textAlign: "center" } },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "5%" }
                ]
        }
        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12}>
                        <div>
                            <Typography variant="headline" component="h3" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {social ? "Post to Socials" : "Upcoming Gigs"}
                                <Tooltip title={
                                    <span>
                                        {social ? this.renderSocialTip() : profileType === "musician" || profileType === "dj" || profileType === "production"
                                            ? "These are your upcoming gigs for the acts you manage and also for gigs you have been booked for by other acts."
                                            : "This is the list of confirmed gigs."}
                                        <br /><br />
                                        <b>Tip:</b> {profileType === "musician"
                                            ? "Click 'View Details' to edit the player lineup or update your set lists."
                                            : "Click 'View Details' to see booking details."}
                                    </span>
                                }>
                                    <HelpOutlineIcon style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} />
                                </Tooltip>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={12} className="booking-table-wrapper" ref={el => (this.componentRef = el)}>
                        <ResponsiveTable
                            showToolbar={profileType !== "musician"}
                            customActions={
                                this.renderTableCustomActions()
                            }
                            selectable={profileType !== "musician"}
                            getCheckedRows={this.getCheckedRows}
                            sortable
                            highLight={bookingHighlight}
                            mobileSecondaryField="venue"
                            columns={newColumns.length ? newColumns : this.state.columns}
                            rows={upcomings.map(booking => {
                                var row = {};
                                let date = new Date(booking.dateStart);
                                // row.date = date.getDate()+" "+this.props.templateStore.getMonth(date.getMonth())+" "+date.getFullYear();
                                row.id = booking.id;
                                
                                row.timeStart = booking.timeStart;
                                row.timeEnd = booking.timeEnd;
                                row.loadInStart = booking.loadInStart;
                                row.loadInEnd = booking.loadInEnd;
                                row.loadInTime = booking.loadInTime;
                                row.soundCheckStart = booking.soundCheckStart;
                                row.soundCheckEnd = booking.soundCheckEnd;
                                row.soundCheckTime = booking.soundCheckTime;
                                row.notes = booking.notes;
                                row.productionNotes = booking.productionNotes;
                                row.gigRequirements = booking.gigRequirements;
                                row.agentContract = booking.agentContract;
                                row.venueId = booking.venueId;
                                row.venueName = booking.venueName || booking.venue?.profileName;
                                
                                var formattedDate = moment(booking.dateStart).format("YYYY-MM-DD")
                                
                                
                                let time = booking.timeStart.length < 8 ? `0${booking.timeStart}` : booking.timeStart;
                                let endTime = booking.timeEnd.length < 8 ? `0${booking.timeEnd}` : booking.timeEnd;
                                var finalDate= moment(formattedDate + ' ' + time)
                                // row.date = {newFormat: `${booking.dateStart.format("ddd, DD MMM YYYY")} ${moment(time).format('hh.mm A')}`, value: finalDate};
                                row.date = {newFormat: 
                                    (
                                        <div className="gig-date-box">
                                            <div className="day-name">{booking.dateStart.format("ddd")}</div>
                                            <div className="date-number">{booking.dateStart.format("DD")}</div>
                                            <div className="month">{booking.dateStart.format("MMM YYYY")}</div>
                                            <div className="time-range">{`${moment(time, 'HH:mm:ss').format('h:mm A')} - ${moment(endTime, 'HH:mm:ss').format('h:mm A')}`}</div>
                                        </div>
                                    ), value: finalDate};
                                row.bookingCreator = booking?.createdBy ? (booking?.createdBy?.firstName + " " +booking?.createdBy?.lastName) : ""
                                row.venue = (
                                    <div>
                                        <span style={{fontWeight: 600}}>{booking.venue ? booking.venue?.profileName : booking.venueName}</span>
                                        <br />
                                        <small style={{color: '#888'}}>{booking.venueAddress}</small>
                                    </div>
                                );
                                // row.address = booking.venueAddress;
                                row.styleHighlight = {
                                    border: "solid",
                                    borderColor: "#FF0C9C"
                                }
                                let agentActOwner = currentProfile?.type === ProfileType.Agent.ordinal && booking.createdById !== currentProfile?.id && booking.act.actAdminId === currentProfile?.id;

                                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                                let actOwner = booking.act?.userId === currentProfile?.userId;

                                row.gigFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (booking.agentOwner?.hideVenueFees && currentProfile?.type === ProfileType.Musician.ordinal) ? <i className={"icon-eye-blocked"} /> :
                                (booking.viewOnly || (currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.allowInvoices))
                                    ? <i class="far fa-eye-slash"></i>  
                                    : `${currentProfile?.currencySymbol + ((profileType === "agent" || profileType === "staff") && booking.isApproved
                                        ? currencyHelper.formatMoney(collectedFee.gigFee + booking.extraGigFee, 2) 
                                        : agentActOwner ? currencyHelper.formatMoney(collectedFee.performanceFee, 2)
                                        : currencyHelper.formatMoney(collectedFee.gigFee, 2))}`;
                                row.agentFee = collectedFee.agentFee

                                row.agentCommissionAmount = collectedFee.agentCommissionAmount
                                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;



                                row.actName = profileType === "musician" ? (
                                    <div>
                                        <div className="gig-act-name">
                                            <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking.act?.id}`}>
                                                {isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act?.actName}
                                            </a>
                                        </div>
                                        {booking.act?.contactName && <div className="gig-act-contact">{booking.act?.contactName}</div>}
                                        {booking.act?.contactPhone && <div className="gig-act-contact">{booking.act?.contactPhone}</div>}
                                    </div>
                                ) : (
                                    <div>
                                        <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking.act?.id}`}>{isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act?.actName}</a>
                                        <br />
                                        {booking.act && <small>Contact: {booking.act?.contactName}</small>}
                                        <br />
                                        {booking.act && <small>Phone: {booking.act?.contactPhone}</small>}
                                    </div>
                                );

                                row.myFee = this.props.profileType === 'musician' && currentProfile?.currencySymbol + currencyHelper.formatMoney(collectedFee.myFee, 2);
                              
                                row.actFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (currentProfile?.type === ProfileType.Staff.ordinal && booking.agentOwner?.hideVenueAgencyFees) ? <i className={"icon-eye-blocked"} /> : agentActOwner ? currentProfile?.currencySymbol + currencyHelper.formatMoney(booking.actFee, 2) : this.props.profileType === "musician" && !actOwner ? "" : currentProfile?.currencySymbol + currencyHelper.formatMoney(booking.actFee, 2);
                               
                             

                                row.superFee = collectedFee.superFee
                                row.feePaidToAct = collectedFee.feePaidToAct
                                
                                row.agentName = booking.agentName;
                                row.time = booking.timeStart.substring(0, 5);

                                let fbPostedStatus = this.state.sharedBookings.includes(booking.id);
                                let fbButtonDisabled = !this.isConnectedToFb(booking) || !booking.sharePermission || booking.type === BookingType.Adhoc.ordinal || isEntertainerBookings;
                                let fbButtonStyle = (this.isConnectedToFb(booking) && booking.sharePermission && booking.type !== BookingType.Adhoc.ordinal && !isEntertainerBookings) ? "fb-share" : "fb-share-disabled";
                                let fbButtonText = (!fbButtonDisabled && booking?.isPostToFacebook) || fbPostedStatus ? "Posted" : "Post to Facebook";
                                let fbHoverText = this.isConnectedToFb(booking) && booking.sharePermission ? "" : "Connect your Facebook page to post this gig to Facebook"                                
                                
                                if(this.props.social &&(currentProfile && currentProfile?.type !== ProfileType.Staff.ordinal) || (currentProfile && currentProfile?.type === ProfileType.Staff.ordinal && !currentProfile?.viewOnly)){
                                    row.socialPosts = (
                                        <Tooltip title={fbHoverText} >
                                            <Button disabled={fbButtonDisabled} className={fbButtonStyle} onClick={() => this.handleSharePost(booking, currentProfile)}>
                                                <img src={facebook} alt="fb" className="logo-fb" />&nbsp;&nbsp;{fbButtonText}
                                            </Button>
                                        </Tooltip>
                                    )
                                }
                              

                                row.purchaseOrder = booking.purchaseOrderCode;

                                row.acknowledge = booking.acknowledge ? (
                                    <Tooltip
                                        title={
                                            <span>
                                                Acknowledge By:{" "}
                                                {`${booking.acknowledgeBy ? booking.acknowledgeBy.firstName : ""} ${
                                                    booking.acknowledgeBy ? booking.acknowledgeBy.lastName : ""
                                                }`}
                                            </span>
                                        }
                                        placement="bottom"
                                    >
                                        <Checkbox checked={true} disableRipple={true} />
                                    </Tooltip>
                                ) : (
                                    <Checkbox
                                        checked={booking.acknowledge}
                                        onChange={() => this.handleAcknowledgeBooking(booking)}
                                        disabled={booking.acknowledge || !booking.canAcknowledge}
                                    />
                                );

                                const bookingRequestUrl = booking.bookingRequestId ? `/${booking.bookingRequestId}` : "";

                                row.isSendBookingDetails = booking.isSendBookingDetails ? <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div>  : null;
                                
                                const handleGetDirections = () => {
                                    const address = encodeURIComponent(booking.venueAddress || '');
                                    window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
                                };
                                
                                const handleViewDetails = () => {
                                    let redirectUrl =
                                        booking.type === BookingType.Adhoc.ordinal
                                            ? `/privateBooking/${booking.id}/edit` + bookingRequestUrl
                                            : currentProfile?.type === ProfileType.Musician.ordinal
                                                ? `/musician/booking/${booking.id}/details`
                                                : agentActOwner
                                                    ? `/musician/booking/${booking.id}/details`
                                                    : currentProfile?.type === ProfileType.Agent.ordinal
                                                        ? `/booking/${booking.id}/edit`
                                                        : currentProfile?.type === ProfileType.Staff.ordinal
                                                            ? `/booking/${booking.id}/edit`
                                                            : "";
                                    process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(redirectUrl, '_blank'):                         
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                };
                                
                                const canEditBooking = booking.type === BookingType.Adhoc.ordinal && booking.createdById === currentProfile?.id;
                                const handleEditBooking = () => {
                                    const redirectUrl = `/privateBooking/${booking.id}/edit`;
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                };
                                const handleCancelBooking = () => {
                                    const redirectUrl = booking.type === BookingType.Adhoc.ordinal
                                        ? `/privateBooking/${booking.id}/edit`
                                        : `/musician/booking/${booking.id}/details`;
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs', openCancelDialog: true });
                                };
                                
                                row.action = profileType === "musician" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <VisibilityIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View Details
                                            </MenuItem>
                                            {canEditBooking && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleEditBooking(); }}>
                                                    <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Edit Booking
                                                </MenuItem>
                                            )}
                                            <MenuItem 
                                                onClick={() => { this.unsetActionAchnor(booking.id); handleGetDirections(); }}
                                                disabled={!booking.venueAddress}
                                            >
                                                <DirectionsIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Get Directions
                                            </MenuItem>
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleCancelBooking(); }}>
                                                <CancelIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Cancel Booking
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                ) : profileType === "agent" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View / Edit
                                            </MenuItem>
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenDuplicateBookingModal(booking); }}>
                                                <FileCopyIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Duplicate Booking
                                            </MenuItem>
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/${booking.id}/sendBookingEmail`); }}>
                                                    <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>✉</span>
                                                    Send Booking Details via Email
                                                </MenuItem>
                                            )}
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/printBookingDetails/${booking.id}`); }}>
                                                    <PrintIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Print Booking Details
                                                </MenuItem>
                                            )}
                                        </Menu>
                                    </div>
                                ) : (
                                    <div className="gig-actions">
                                        <Tooltip title={booking.venueAddress ? "Get Directions" : "No address available"}>
                                            <span>
                                                <IconButton 
                                                    className="gig-action-btn" 
                                                    onClick={handleGetDirections}
                                                    disabled={!booking.venueAddress}
                                                    style={!booking.venueAddress ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                                                >
                                                    <DirectionsIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="View Details">
                                            <IconButton 
                                                className="gig-action-btn" 
                                                onClick={handleViewDetails}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (
                                            <Fragment>
                                                <Tooltip title="More Actions">
                                                    <IconButton 
                                                        className="gig-action-btn" 
                                                        onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                                    >
                                                        <span style={{fontSize: '18px', fontWeight: 'bold'}}>...</span>
                                                    </IconButton>
                                                </Tooltip>
                                                {booking.id && (
                                                    <Menu
                                                        open={this.state.actionAnchor[booking.id] != null}
                                                        onClose={() => this.unsetActionAchnor(booking.id)}
                                                        anchorEl={this.state.actionAnchor[booking.id]}
                                                    >
                                                        <MenuItem onClick={() => this.handleOpenDuplicateBookingModal(booking)}>Duplicate Booking</MenuItem>
                                                    </Menu>
                                                )}
                                            </Fragment>
                                        )}
                                    </div>
                                )
                                
                                
                            

                                row.status = <BookingStatusBadge isPrint={true} status={this.getBookingStatus(booking)} />;
                                // row.interested = booking.interested.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                // row.going = booking.going.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                
                                return row;
                            })}
                            mobileCardRenderer={profileType === "musician" ? this.renderMobileGigCard : profileType === "agent" ? this.renderAgentMobileGigCard : undefined}
                            footerRow = {
                                currentProfile?.type === ProfileType.Agent.ordinal? 
                                    this.renderFooterRow() : undefined
                            }
                        />
                    </Grid>

                    <Grid item style={{marginTop: 25}} xs={12} key="more" alignContent="center" alignItems="center" justify="center">
                        <Grid container direction="row" justify="center" alignItems="center">
                            {this.props.bookingRequestStore.showMoreUpcoming ? (
                                <Button variant="outlined" size="large" color="primary" onClick={this.handleShowMore}>
                                    Show More
                                </Button>
                            ) : null}
                        </Grid>
                    </Grid>
                </Grid>

                
                <Snackbar
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    open={this.state.acknowledgeSnackbarState}
                    onClose={this.closeAcknowledgeSnackbar}
                    autoHideDuration={5000}
                    message={
                        <span id="message-id">{`${
                            this.state.booking ? this.props.bookingRequestStore.getBookingTitle(this.state.booking) : "Selected gigs"
                        } has been acknowledged.`}</span>
                    }
                    action={[
                        <Button color="primary" size="small" onClick={this.handleUndoAcknowledge}>
                            UNDO
                        </Button>,
                        <IconButton onClick={this.closeAcknowledgeSnackbar} color="primary">
                            <ClearIcon />
                        </IconButton>
                    ]}
                />
                {FACEBOOK_ENABLED && <FacebookPostDialog profileType="venue" callback={this.openAcknowledgeSnackbar} />}

                {FACEBOOK_ENABLED && <FacebookSharePostDialog profileType="musician" reloadData={this.updatedSharedBookingState}/>}

                <ConfirmationModal
                    open={this.state.duplicateModalState}
                    message={`Are you sure you want to duplicate this booking - ${this.state.duplicateBooking?.title}?`}
                    closeHandler={this.handleCloseDuplicateBookingModal}
                    confirmationHandler={this.handleDupicateRequest}
                    declineHandler={this.handleCloseDuplicateBookingModal}
                    confirmationLabel="Duplicate"
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    open={this.state.openDuplicateSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleSnackbarEditClose}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">Booking {this.state.duplicateBooking?.title} duplicated</span>}
                    action={
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarEditClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                />
                <PrintModal 
                    open = { showPrintOption }
                    closeHandler = { this.closePrintOptionModal }
                    bookings = { selectedBookings }
                />
                <BulkEditModal
                    open={this.state.bulkEditModalOpen}
                    onClose={this.closeBulkEditModal}
                    selectedBookings={selectedBookings.map(row => upcomings.find(b => b.id === row.id)).filter(b => b && this.isRelatedCreator(b))}
                    onSubmit={this.handleBulkEditSubmit}
                />
                <BulkCancelModal
                    open={this.state.bulkCancelModalOpen}
                    onClose={this.closeBulkCancelModal}
                    selectedBookings={selectedBookings.map(row => upcomings.find(b => b.id === row.id)).filter(b => b && this.isRelatedCreator(b) && CANCELLABLE_STATUSES.includes(b.status))}
                    onComplete={this.handleBulkCancelComplete}
                />
            </Fragment>
        );
    }
}

export default BookingAccepted;
